import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { datadogRum } from '@datadog/browser-rum';
import { AppModule } from './app/app.module';
import { environment } from './app/environments/environment';

export function getBaseUrl() {
  return environment.companyApiUrl;
}

const providers = [{ provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }];

if (environment.production) {
  enableProdMode();
}

function initializeDatadog(serviceName: string) {
  const config: any = {
    applicationId: environment.datadogAppId,
    clientToken: environment.datadogClientToken,
    site: 'us3.datadoghq.com',
    service: serviceName,
    env: environment.environmentName,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  };
  datadogRum.init(config);
  datadogRum.startSessionReplayRecording();
}

export function onUserLogin(user: { id: string; companyId?: number; name?: string; email?: string }) {
  const serviceName = user.companyId === 1 ? 'admin-portal-web' : 'company-portal-web';
  initializeDatadog(serviceName);
  datadogRum.setUser({
    id: user.id,
    name: user.name,
    email: user.email,
    companyId: user.companyId,
  });
}

export function onUserLogout() {
  datadogRum.clearUser();
}

window.onbeforeunload = () => {
  onUserLogout();
};

platformBrowser(providers)
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
